import React from 'react';
import { Card, CardContent, Typography, Box, Button } from '@mui/material';
import { TrendingUp, Bolt, CompareArrows } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const QuickActions: React.FC = () => {
  const navigate = useNavigate();

  const actions = [
    { icon: <TrendingUp />, label: 'Neuen Trade ausführen', path: '/paper-trading', color: 'primary' as const },
    { icon: <Bolt />, label: 'Neue Strategie erstellen', path: '/strategies', color: 'secondary' as const },
    { icon: <CompareArrows />, label: 'Strategien vergleichen', path: '/strategies', color: 'success' as const },
  ];

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} gutterBottom>Schnellzugriff</Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          {actions.map((a, i) => (
            <Button
              key={i}
              variant="outlined"
              color={a.color}
              startIcon={a.icon}
              onClick={() => navigate(a.path)}
              sx={{ justifyContent: 'flex-start', borderRadius: 2, textTransform: 'none' }}
            >
              {a.label}
            </Button>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
